import React, { useState } from 'react';
import Nav from './components/Nav';
import IntroHome from './components/Intro';
import About from './components/About';
import HouseCard from './components/HouseCard';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Form from './components/Form';
import Chiesa from './assets/images/realizations/chiesa-caselle.jpg';
import Patronato from './assets/images/realizations/patronato-caselle.png';
import Rustico1 from './assets/images/realizations/caselle-rustico.jpg';
import Bifamiliare1 from './assets/images/projects/caselle_bifamiliare_1.png';
import Bifamiliare2 from './assets/images/projects/caselle_bifamiliare_nordovest_1.png';
import Bifamiliare3 from './assets/images/projects/caselle_bifamiliare_sud_1.png';
import './assets/stylesheets/App.css';
import './assets/stylesheets/Mobile.css';

function App() {
  const [realizationsMain] = useState([
    Chiesa,
    Patronato
  ]);

  const [realizations] = useState([
    Chiesa,
    Patronato,
    Rustico1,
    Chiesa,
    Patronato,
    Rustico1,
  ]);

  const [proposals] = useState([
    Bifamiliare1,
    Bifamiliare2,
    Bifamiliare3,
  ]);

  const [proposalsMain] = useState([
    Bifamiliare1,
    Bifamiliare2,
  ]);

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [currentRealizationsIndex, setCurrentRealizationsIndex] = useState(0);
  const [currentProposalsIndex, setCurrentProposalsIndex] = useState(0);

  const handleEmailChange = (newEmail) => {
    setEmail(newEmail);
  };

  const handleNameChange = (newName) => {
    setName(newName);
  };

  const handleSubjectChange = (newSubject) => {
    setSubject(newSubject);
  };

  const handlePhoneChange = (newPhone) => {
    setPhone(newPhone);
  };

  const handleMessageChange = (newMessage) => {
    setMessage(newMessage);
  };

  const handlePrevRealizationImage = () => {
    setCurrentRealizationsIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextRealizationImage = () => {
    setCurrentRealizationsIndex((prevIndex) => Math.min(prevIndex + 1, realizations.length - 3));
  };

  const handlePrevProposalImage = () => {
    setCurrentProposalsIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextProposalImage = () => {
    setCurrentProposalsIndex((prevIndex) => Math.min(prevIndex + 1, proposals.length - 3));
  };

  return (
    <div>
      <Nav />
      <IntroHome />
      <About />
      <p className="display-6 title fw-semibold about-title" id='realizzazioni' style={{ fontSize: "30px", marginTop: "70px" }}>LE NOSTRE REALIZZAZIONI</p>
      <div className="row row-cols-1 row-cols-md-2 g-4 card-group">
        {realizationsMain.map((img, index) => (
          <div key={index} className="col">
            <HouseCard
              imgHouse={img}
            />
          </div>
        ))}
      </div>
      <div className="row row-cols-1 row-cols-md-3 g-4 card-group mt-2 carousel-houses">
        {realizations.slice(currentRealizationsIndex, currentRealizationsIndex + 3).map((img, index) => (
          <div key={index} className="col">
            <HouseCard
              imgHouse={img}
              isFirstGroup={index === 0}
              isLastGroup={index === 2}
              onPrevClick={handlePrevRealizationImage}
              onNextClick={handleNextRealizationImage}
            />
          </div>
        ))}
      </div>
      <p className="display-6 title fw-semibold about-title" id='proposte_edili' style={{ fontSize: "30px", marginTop: "70px" }}>LE NOSTRE PROPOSTE EDILI</p>
      <div className="row row-cols-1 row-cols-md-2 g-4 card-group main-houses">
        {proposalsMain.map((img, index) => (
          <div key={index} className="col">
            <HouseCard
              imgHouse={img}
            />
          </div>
        ))}
      </div>
      <div className="row row-cols-1 row-cols-md-3 g-4 card-group mt-2 carousel-houses">
        {proposals.slice(currentProposalsIndex, currentProposalsIndex + 3).map((img, index) => (
          <div key={index} className="col">
            <HouseCard
              imgHouse={img}
              isFirstGroup={index === 0}
              isLastGroup={index === 2}
              onPrevClick={handlePrevProposalImage}
              onNextClick={handleNextProposalImage}
            />
          </div>
        ))}
      </div>

      <Form
        emailValue={email}
        nameValue={name}
        subjectValue={subject}
        messageValue={message}
        phoneValue={phone}
        setEmail={handleEmailChange}
        setName={handleNameChange}
        setSubject={handleSubjectChange}
        setMessage={handleMessageChange}
        setPhone={handlePhoneChange}
      />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
